module.exports = __webpack_public_path__ + "static/media/dashboard.5bb467ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/portfolio/classvalet/dashboard.png
// module id = 239
// module chunks = 0